import constants from "../../core/constants";

import addBackupPlansDialogTemplate from "./addBackupPlansDialog/addBackupPlansDialog.html";
import addBackupPlansDialogController from "./addBackupPlansDialog/addBackupPlansDialog.controller";

class Controller {
  constructor(
    Events,
    Messages,
    $mdDialog,
    $state,
    Sections,
    $stateParams,
    BackupPlan
  ) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
    this.filterEvent = this.Events.getFilterEvent("backupplan");
    this.paginateEvent = this.Events.getPaginateEvent("backupplan");
    this.sortEvent = this.Events.getSortEvent("backupplan");

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;

    this.$state = $state;
    this.sections = Sections.plansSections;
    this.BackupPlan = BackupPlan;
    this.Messages = Messages;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  openDialog() {
    this.$mdDialog
      .show({
        controller: addBackupPlansDialogController,
        controllerAs: "$ctrl",
        template: addBackupPlansDialogTemplate,
        locals: {
          chosenCity: this.chosenCity,
        },
      })
      .then(({ description, name, wage, city: { _id } }) => {
        wage *= constants.currencyBy;

        this.BackupPlan.post({
          description,
          name,
          wage,
          city: _id,
        }).$promise.then(
          ({ _id }) => {
            this.Events.emit(
              this.successNotificationEvent,
              this.Messages.addMessage("Backup Plan")
            );
            this.$state.transitionTo("backupplan", {
              id: _id,
            });
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backupplans/backupplans.controller.js